module.exports = __webpack_public_path__ + "static/media/14UNEP3.e4000bf8.jpg";